<template lang="html">
  <div class="vaginal-kit mt-5">
    <div class="vaginal-kit-img">
      <img src="../../assets/img/vaginal-kit-box.svg" alt="">
    </div>
    <div class="vaginal-kit-text">
      <h2>GET YOUR ANNUAL VAGINAL KIT!</h2>
      <p class="mt-3">- DISCOVER</p>
      <p>Fully know and understand your unique vaginal ecosystem.</p>
      <p class="mt-2">- MONITOR</p>
      <p>Keep track of your female health from the comfort of your own home - no more unnecessary visits to the doctor.</p>
      <p class="mt-2">- STAY HEALTHY</p>
      <p>he HPV and STIs test will help you detect any risk right away.</p>
      <p class="mt-2">- BE INFORMED</p>
      <p>Gain access to Ginny, your personalized digital assistant, available through the app 24/7 to answer any questions you might
        have</p>
      <b><img src="../../assets/img/gift.svg" alt="" class="inline-svg-style mr-3 pb-2">1 emergency box. </b>
      <p>Because sometimes shit happens. We’re always here to help.</p>
      <b-button pill size="lg" variant="danger" class="pr-5 pl-5 pt-3 pb-3 mt-3" v-b-modal.modal-1>I WANT THIS</b-button>
    </div>

    <b-modal id="modal-1" title="BootstrapVue" size="lg" centered hide-footer>
      <template v-slot:modal-title>
        <span class="blue-text">Thank you!</span>
      </template>
      <div class="p-2">
        <div class="mt-2 mb-3 text-center">
          <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44.85 59.57"><title>Untitled-1</title><path d="M37.13,2.22H33.69A24.25,24.25,0,0,0,9.57,26.41v1.11A24.14,24.14,0,0,0,22,48.57a19.74,19.74,0,0,0,5.15,2.14v11S54.43,65,54.43,32.24V7.36S46.34,2.56,37.13,2.22Z" transform="translate(-9.57 -2.22)" style="fill:#3a62cc"/></svg>
        </div>
          <SignupForm />
        <div class="mb-5"></div>
      </div>

    </b-modal>

  </div>
</template>

<script>
import SignupForm from '../Forms/SignupForm'
export default {
  components: {
    SignupForm,
  },
}
</script>

<style lang="scss" scoped>
  .vaginal-kit {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    grid-auto-rows: minmax(.5fr, auto);
    grid-gap: 1em;
  }
  .vaginal-kit-img {
    grid-column: 2/12;
    grid-row: 1;
  }
  .vaginal-kit-text {
    grid-column: 2/12;
    grid-row: 2;
    text-align: left;
  }
  .inline-svg-style {
    width: 30px;
    height: auto;
  }
  @media (min-width: 992px) {
    .vaginal-kit-img {
      grid-column: 7/13;
      grid-row: 4;
      align-self: right;
    }
    .vaginal-kit-text {
      grid-column: 2/9;
      grid-row: 1/12;
      text-align: left;
    }
  }
  @media (min-width: 1200px) {
    .vaginal-kit-img {
      grid-column: 8/11;
      grid-row: 4;
      align-self: right;
    }
    .vaginal-kit-text {
      grid-column: 3/8;
      grid-row: 1/12;
      text-align: left;
    }
    .vaginal-kit {
      padding-bottom: 5em;
    }
  }
</style>
